import ConstantApi from '../../ConstantApi';
import { fetchAccessoriesUsageDetails } from '../accessoriesUsage/accesoriesUsage.actions';
import axiosCall from '../axiosCall';
import { fetchColorDetailsWithoutId } from '../colorDetails/colorDetails.actions';
import { fetchHSNMaster } from '../hsnMaster/hsnMaster.actions';
import { fetchPropertyDataForSizeDetailsMaster } from '../sizeMeasurementDetails/sizeMeasurementDetails.action';
import {
    CREATE_ACCESSORIS_MASTER_FAILURE,
    CREATE_ACCESSORIS_MASTER_FORM,
    CREATE_ACCESSORIS_MASTER_REQUEST,
    CREATE_ACCESSORIS_MASTER_SUCCESS,
    DELETE_ACCESSORIS_MASTER_FAILURE,
    DELETE_ACCESSORIS_MASTER_REQUEST,
    DELETE_ACCESSORIS_MASTER_SUCCESS,
    FETCH_ACCESSORIS_MASTER_FAILURE,
    FETCH_ACCESSORIS_MASTER_FOR_SIZE_FAILURE,
    FETCH_ACCESSORIS_MASTER_FOR_SIZE_REQUEST,
    FETCH_ACCESSORIS_MASTER_FOR_SIZE_SUCCESS,
    FETCH_ACCESSORIS_MASTER_REQUEST,
    FETCH_ACCESSORIS_MASTER_SUCCESS,
    FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_FAILURE,
    FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_REQUEST,
    FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_SUCCESS,
    FETCH_SINGLE_ACCESSORIS_MASTER_FAILURE,
    FETCH_SINGLE_ACCESSORIS_MASTER_REQUEST,
    FETCH_SINGLE_ACCESSORIS_MASTER_SUCCESS,
    RESET_ACCESSORIS_MASTER_INFO,
    UPDATE_ACCESSORIS_MASTER_FAILURE,
    UPDATE_ACCESSORIS_MASTER_REQUEST,
    UPDATE_ACCESSORIS_MASTER_SUCCESS
} from './accessoriesMaster.actionsType';

// FETCH ACCESSORIES MASTER DATA
export let fetchAccessoriesMaster = () => {
    let config = {
        method: 'get',
        url: ConstantApi.accessoriesMasterGET,
        responseTypeRequest: FETCH_ACCESSORIS_MASTER_REQUEST,
        responseTypeSuccess: FETCH_ACCESSORIS_MASTER_SUCCESS,
        responseTypeFailure: FETCH_ACCESSORIS_MASTER_FAILURE
    };
    return axiosCall(config);
};

// CREATE ACCESSORIES MASTER FORM
export let createAccessoriesMasterForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_ACCESSORIS_MASTER_FORM, payload: { key, value } });
    };
};

// CREATE ACCESSORIES MASTER
export let createAccessoriesMaster = (formData, modalClose) => {
    console.log(formData, 'lllllllllll');
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldIsActive: true,
        fldCreatedBy: 1,
        fldCreatedDt: today.toISOString(),
        fldModifiedBy: 0,
        fldModifiedDt: today.toISOString(),
        fldDeletedBy: 0,
        fldDeletedDt: today.toISOString(),
        fldCode: '',
        ...formData,
        fldFKType: parseInt(formData.fldFKType),
        fldPurchaseCostConversionRate: Number(formData.fldPurchaseCostConversionRate),
        fldCostPurchaseConversionRate: Number(formData.fldCostPurchaseConversionRate),
        fldFKCategory: parseInt(formData.fldFKCategory),
        fldFKSubcategory: parseInt(formData.fldFKSubcategory),
        fldFKBrand: parseInt(formData.fldFKBrand),
        fldFKSource: parseInt(formData.fldFKSource),
        fldColorInfo: 'string',
        fldSizeInfo: 'string',
        fldSizeDetail: formData?.fldSizeDetail?.length > 0 ? formData?.fldSizeDetail.toString() : formData.fldSizeDetail,
        fldColorDetail: formData?.fldColorDetail?.length > 0 ? formData?.fldColorDetail.toString() : formData.fldColorDetail,
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKIIUOM: formData.fldFKIIUOM ? parseInt(formData.fldFKIIUOM) : 0,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKSizeOption: Number(formData.fldFKSizeOption),
        fldTransitDays: formData.fldTransitDays ? parseInt(formData.fldTransitDays) : 0,
        fldFKAccessoriesUsage: parseInt(formData.fldFKAccessoriesUsage),
        fldMinStockQuantity: formData.fldMinStockQuantity
            ? formData.fldMinStockQuantity.split('.').length >= 2
                ? parseFloat(formData.fldMinStockQuantity)
                : parseInt(formData.fldMinStockQuantity)
            : 0,
        fldPurchasePrice: formData?.fldPurchasePrice
            ? formData.fldPurchasePrice.split('.').length >= 2
                ? parseFloat(formData.fldPurchasePrice)
                : parseInt(formData.fldPurchasePrice)
            : 0,
        fldJobworkPrice: formData?.fldJobworkPrice
            ? formData.fldJobworkPrice.split('.').length >= 2
                ? parseFloat(formData.fldJobworkPrice)
                : parseInt(formData.fldJobworkPrice)
            : 0,
        fldProcessPrice: formData?.fldProcessPrice
            ? formData.fldProcessPrice.split('.').length >= 2
                ? parseFloat(formData.fldProcessPrice)
                : parseInt(formData.fldProcessPrice)
            : 0
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.accessoriesMasterPOST}`,
        responseTypeRequest: CREATE_ACCESSORIS_MASTER_REQUEST,
        responseTypeSuccess: CREATE_ACCESSORIS_MASTER_SUCCESS,
        responseTypeFailure: CREATE_ACCESSORIS_MASTER_FAILURE,
        resetFormData: RESET_ACCESSORIS_MASTER_INFO,
        modalClose,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchAccessoriesMaster()
    };
    return axiosCall(config);
};

// GET SINGLE ACCESSORIES MASTER
export let getSingleAccessories = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.accessoriesMasterGET_SINGLE_USER_ID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_ACCESSORIS_MASTER_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_ACCESSORIS_MASTER_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_ACCESSORIS_MASTER_FAILURE,
        singlApiArray: [
            fetchPropertyDataForAccessoriesMaster(40),
            fetchPropertyDataForAccessoriesMaster(41),
            fetchPropertyDataForAccessoriesMaster(42),
            fetchPropertyDataForAccessoriesMaster(12),
            fetchPropertyDataForAccessoriesMaster(45),
            fetchPropertyDataForAccessoriesMaster(46),
            fetchPropertyDataForAccessoriesMaster(47),
            fetchPropertyDataForAccessoriesMaster(38),
            fetchPropertyDataForAccessoriesMaster(44),
            fetchPropertyDataForAccessoriesMaster(81),
            fetchColorDetailsWithoutId(),
            fetchPropertyDataForSizeDetailsMaster(22),
            fetchHSNMaster(),
            fetchAccessoriesUsageDetails()
        ]
    };
    return axiosCall(config);
};

//UPDATE ACCESSORIES MASTER
export let updateAccessoriesMaster = (formData) => {
    let today = new Date();
    let data = {
        ...formData,
        fldModifiedBy: 1,
        fldModifiedDt: today.toISOString(),
        fldFKType: parseInt(formData.fldFKType),
        fldFKCategory: parseInt(formData.fldFKCategory),
        fldFKSubcategory: parseInt(formData.fldFKSubcategory),
        fldFKBrand: parseInt(formData.fldFKBrand),
        fldFKSource: parseInt(formData.fldFKSource),
        // fldColorDetail: parseInt(formData.fldColorDetail),
        fldColorInfo: formData.fldColorInfo,
        fldSizeInfo: formData.fldSizeInfo,
        fldSizeDetail: formData?.fldSizeDetail?.length > 0 ? formData?.fldSizeDetail.toString() : formData.fldSizeDetail,
        fldColorDetail: formData?.fldColorDetail?.length > 0 ? formData?.fldColorDetail.toString() : formData.fldColorDetail,
        fldFKUOM: parseInt(formData.fldFKUOM),
        fldFKIIUOM: formData.fldFKIIUOM ? parseInt(formData.fldFKIIUOM) : 0,
        fldFKHSNCode: parseInt(formData.fldFKHSNCode),
        fldFKSizeOption: Number(formData.fldFKSizeOption),
        fldTransitDays: formData.fldTransitDays ? parseInt(formData.fldTransitDays) : 0,
        fldCostPurchaseConversionRate: Number(formData.fldCostPurchaseConversionRate),
        fldPurchaseCostConversionRate: Number(formData.fldPurchaseCostConversionRate),
        // fldFKSize: parseInt(formData.fldFKSize),
        fldFKAccessoriesUsage: parseInt(formData.fldFKAccessoriesUsage),
        fldMinStockQuantity: formData.fldMinStockQuantity
            ? formData.fldMinStockQuantity.split('.').length >= 2
                ? parseFloat(formData.fldMinStockQuantity)
                : parseInt(formData.fldMinStockQuantity)
            : 0,
        fldPurchasePrice: formData?.fldPurchasePrice
            ? formData.fldPurchasePrice.split('.').length >= 2
                ? parseFloat(formData.fldPurchasePrice)
                : parseInt(formData.fldPurchasePrice)
            : 0,
        fldJobworkPrice: formData?.fldJobworkPrice
            ? formData.fldJobworkPrice.split('.').length >= 2
                ? parseFloat(formData.fldJobworkPrice)
                : parseInt(formData.fldJobworkPrice)
            : 0,
        fldProcessPrice: formData?.fldProcessPrice
            ? formData.fldProcessPrice.split('.').length >= 2
                ? parseFloat(formData.fldProcessPrice)
                : parseInt(formData.fldProcessPrice)
            : 0
    };
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.accessoriesMasterPATCH}/${formData.fldId}`,
        responseTypeRequest: UPDATE_ACCESSORIS_MASTER_REQUEST,
        responseTypeSuccess: UPDATE_ACCESSORIS_MASTER_SUCCESS,
        responseTypeFailure: UPDATE_ACCESSORIS_MASTER_FAILURE,
        resetFormData: RESET_ACCESSORIS_MASTER_INFO,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchAccessoriesMaster()
    };
    return axiosCall(config);
};

// DELETE ACCESSORIES MASTER
export let deleteAccessoriesMaster = (id) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.accessoriesMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_ACCESSORIS_MASTER_REQUEST,
        responseTypeSuccess: DELETE_ACCESSORIS_MASTER_SUCCESS,
        responseTypeFailure: DELETE_ACCESSORIS_MASTER_FAILURE,
        modalClose: true,
        resetFormData: RESET_ACCESSORIS_MASTER_INFO,
        getAllData: fetchAccessoriesMaster()
    };
    return axiosCall(config);
};

export let fetchPropertyDataForAccessoriesMaster = (propertyId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.PropertyList}/${propertyId}`,
        responseTypeRequest: FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_REQUEST,
        responseTypeSuccess: FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_SUCCESS,
        responseTypeFailure: FETCH_PROPERTY_DATAS_FOR_ACCESORIES_MASTER_FAILURE,
        payload: propertyId
    };
    return axiosCall(config);
};

export let fetchForSizesAccessoriesMaster = (style) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.accessoriesMasterForSizes}?FldId=${style}`,
        responseTypeRequest: FETCH_ACCESSORIS_MASTER_FOR_SIZE_REQUEST,
        responseTypeSuccess: FETCH_ACCESSORIS_MASTER_FOR_SIZE_SUCCESS,
        responseTypeFailure: FETCH_ACCESSORIS_MASTER_FOR_SIZE_FAILURE
    };
    return axiosCall(config);
};
